import { useTranslation } from "next-i18next";

import { Button } from "@filadd/phi-plus-core";
import { css } from "@filadd/phi-plus-styled-system/css";

interface Props {
  title: string;
  courseSlug: string;
  programUnitShortSlug: string;
  blocksShortSlug: string;
}

export const PendingDiagnostic = ({
  title,
  courseSlug,
  programUnitShortSlug,
  blocksShortSlug,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={css({
        display: "flex",
        alignItems: "center",
        flexGrow: 1,
        marginBottom: 2,
        gap: 2,
      })}
    >
      <div className={css({ display: "flex", alignItems: "center" })}>
        <p>{title}</p>
      </div>
      <div>
        <Button
          variant="outline"
          size="sm"
          colorPalette="white"
          className={css({
            bgColor: "transparent",

            _hover: {
              bgColor: "primary.800",
            },
          })}
          asChild
        >
          <a
            href={`/courses/${courseSlug}/units/${programUnitShortSlug}/blocks/${blocksShortSlug}`}
            target="_blank"
            rel="noreferrer"
          >
            {t("pendingDiagnostic:action")}
          </a>
        </Button>
      </div>
    </div>
  );
};
